// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var emphasis = "LiveScores-module--emphasis--450af";
export var green = "#57d33b";
export var greenLink = "LiveScores-module--green-link--bf5d6";
export var grey = "var(--tone-mid)";
export var isActive = "LiveScores-module--isActive--88a1c";
export var losing = "LiveScores-module--losing--dc523";
export var name = "LiveScores-module--name--bb484";
export var notchGap = "32px";
export var orange = "#f8662b";
export var periodScore = "LiveScores-module--periodScore--74742";
export var red = "#ff2741";
export var scores = "LiveScores-module--scores--0ee5a";
export var total = "LiveScores-module--total--59bd2";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var winning = "LiveScores-module--winning--de8de";
export var yellow = "#ffb100";